import { Component, OnInit } from '@angular/core';
import { LibrariesService } from '../../services/libraries-service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Libraries } from '../../models/libraries';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-library',
  templateUrl: './add-library.component.html',
  styleUrls: ['./add-library.component.scss'],
})
export class AddLibraryComponent implements OnInit {
  model = {} as Libraries;
  isEdit = false;
  constructor(
    private service: LibrariesService,
    private diagRef: NbDialogRef<AddLibraryComponent>,
    private toast: NbToastrService,
    private route : Router
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    if (!this.isEdit) {
      this.model.descriptionAR = '';
      this.model.descriptionEN = '';
    }
  }

  save() {
    this.service.post(this.model).subscribe((res) => {
      this.diagRef.close('true');
      this.toast.show('تم إضافة مكتبة جديدة بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

  update() {
    this.service.put(this.model.id, this.model).subscribe((res) => {
      this.diagRef.close('true');
      this.toast.show('تم تعديل المكتبة  ', '', { status: 'success', duration: 3000 });
    });
  }

  close() {
    this.diagRef.close();
  }

  isFormValid() {
    return this.model.nameAR && this.model.nameAR.trim() !== '' ;
  }
}
